import { GroupService } from '../../Services/group.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-group-list',
  template: require('./group-list.component.html'),
  styles: [require('./group-list.component.css')]
})
export class GroupListComponent implements OnInit {
  groups: any[] = [];
  constructor(private groupservice: GroupService) { }

  ngOnInit() {
    this.groupservice.getGroupNames(true).subscribe(
      g => {
        this.groups = g;
        // console.log(this.groups);
      }
    )
  }

  changeOpenForSubscription(id: number){
    this.groupservice.changeGroupHidden(id).subscribe ( (res:any)=>{
      if (res.status == 200){
        var f = this.groups.findIndex ( e => e.id == res.value.id)
        this.groups[f].hidden = res.value.hidden
      }
    })    
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/group-list/group-list.component.ts